import { CACHE_TTL_HOURS } from '@modules/TechniciansModule';

const strings = {
  header: {
    name: 'Name',
    tenant: 'Tenant',
    phoneNumber: 'Phone Number',
  },
  search: {
    placeholder: 'Search for technician name or number',
  },
  empty: {
    noTechnicians: {
      title: 'No technicians available',
      body: 'No technicians found for your locations. Please contact your administrator.',
    },
    noSearchResults: {
      title: 'No results found',
      body: `Try another search, allow up to ${CACHE_TTL_HOURS} ${CACHE_TTL_HOURS === 1 ? 'hour' : 'hours'} for newly added technicians to appear.`,
    },
  },
  error: {
    allFailed: {
      title: 'Unable to load technicians',
      body: 'Service is experiencing delays. You can still dial using the keypad.',
    },
    partial: {
      title: 'Temporary issue loading technicians',
      body: "We're having trouble loading all technicians. Try again to refresh the list.",
    },
  },
};

export default strings;
